import React from 'react';
import { ContentTemplate } from 'themes/layouts';

function Content(props) {
    return <ContentTemplate {...props} />;
}

export default Content;
